

define(['squid/index'], function (squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    squid.module('xomodel.ppcartMapper', ['squid']).factory('$PPCartMapperModel', function ($Model, $Api) {
        return $Model.extend('$PPCartMapperModel', {
            api: new $Api({
                uri: '/api/ppcartmapper',
                postAttempts: 2,
                cache: true
            })
        });
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-models/src/ppcartMapper/index.js
// module id = ./components/xo-models/src/ppcartMapper/index.js
// module chunks = 1